import React, { Fragment, useState } from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import DatePicker from "react-date-picker";

import '../styles/_adminSearch.scss';

const AdminSearch = ({
  user,
  searchUsers,
  members, // activity stat
  yearWashes, // activity stat
  bt, // activity stat
  qr, // activity stat
  code // activity stat
}) => {
  const [member, setMember] = useState('');
  const [onlyActive, setOnlyActive] = useState(false);
  const [vehicle, setVehicle] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const path = useLocation().pathname;

  return (
    <div className="admin-search" style={user ? {opacity: 0} : null}>
      <div className={`search-form ${!path.includes('admin') ? 'extended' : ''} ${path.includes('activity') ? 'activity' : ''}`}>
        {path.includes('admin') &&
          <span>Search By:</span>
        }
        {user &&
          <h2>{" "}</h2>
        }
        {path.includes('members') &&
          <Fragment>
            <input type="text" placeholder="First Name / Last Name" value={member} onChange={(e) => setMember(e.target.value)}></input>
            <input type="text" placeholder="Year / Make / Model" onChange={(e) => setVehicle(e.target.value)}></input>
            <label className="container">Show Active Only
              <input type="checkbox" checked={onlyActive} onChange={() => setOnlyActive(!onlyActive)}></input>
              <span className="checkmark"></span>
            </label>
            <div className="btn primary small" onClick={() => searchUsers(member, vehicle, onlyActive)}>Go</div>
          </Fragment>
        }
        {path.includes('activity') &&
          <Fragment>
            <DatePicker
              calendarIcon={null}
              className={"datepicker"}
              value={startDate}
              onChange={(date) => setStartDate(date)}
            />
            <DatePicker
              calendarIcon={null}
              className={"datepicker"}
              value={endDate}
              onChange={(date) => setEndDate(date)}
            />
            <div className="btn primary small" onClick={() => searchUsers(startDate, endDate)}>Go</div>
          </Fragment>
        }
      </div>
      {path.includes('activity') &&
        <div className="search-form stats">
          <div className="stat">
            <p className="smaller">Total Members</p>
            <h1>{members}</h1>
          </div>
          <div className="stat">
            <p className="smaller">{ moment().format('YYYY')} Washes</p>
            <h1>{yearWashes}</h1>
          </div>
          <div className="stat">
            <p className="smaller">QR Access</p>
            <h1>{qr}</h1>
          </div>
          <div className="stat">
            <p className="smaller">BT Access</p>
            <h1>{bt}</h1>
          </div>
          <div className="stat">
            <p className="smaller">Code Access</p>
            <h1>{code}</h1>
          </div>
        </div>
      }
    </div>
  )
}

export default AdminSearch;